export function delayPromise(delayMs: number) {
    return new Promise(r => setTimeout(r, delayMs));
}
